import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  AFFILIATE_TRANSACTIONS,
  NOTIFICATION,
} from '../actionTypes';

const fetchAffiliateTransactions = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.AFFILIATE_TRANSACTIONS}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.AFFILIATE_TRANSACTIONS}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.AFFILIATE_TRANSACTIONS}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.AFFILIATE_TRANSACTIONS}${query}${sorting}`);
};

export function* getAffiliateTransactions(action) {
  try {
    const { data: { entity } } = yield call(fetchAffiliateTransactions, action.payload);
    yield put({ type: AFFILIATE_TRANSACTIONS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: AFFILIATE_TRANSACTIONS.FAILED, payload: e.response.data });
  }
}
